import type { AuthRepositoryPort } from "../ports/auth.repository.port";

export function logoutUseCase(repository: AuthRepositoryPort, refreshToken: string) {
  return repository.logout(refreshToken);
}
